import type { WorkspaceSubscriptionStatus } from '@easy-expense/data-schema-v2';

/**
 * Whether this workspace's coverage is positively known to come from somewhere other than Paddle,
 * and so Paddle's own billing-info/usage functions can be skipped entirely.
 *
 * "Positively known" is the whole point, and is why a null `subscriptionSource` is NOT enough. The
 * legacy Organization-level coverage path reports `active: true` with a null source (it marks an
 * org active off `subscriptionExpiryDate` alone — see `orgIsActive` in the backend's
 * workspaceSubscriptionStatus), and a bare `!== 'paddle'` test reads that null as "not Paddle" and
 * skips the lookup. Nothing downstream agrees: `isOwnMobileSubscription` and
 * `computeIsCoveredByTeammate` both require a non-null source / covering user, so the page renders
 * neither subscribed view — it falls through to the paywall with `billingUsage` left null, and
 * `hasEverSubscribed` reads as `undefined` there, pitching a returning customer a free trial that
 * checkout then refuses to sell them.
 *
 * An unknown source means we don't know, and not knowing is a reason to ask Paddle, not to skip it.
 */
export function computeHasNoPaddleInvolvement(
  status: WorkspaceSubscriptionStatus | null | undefined,
): boolean {
  return (
    status?.active === true &&
    status.subscriptionSource !== null &&
    status.subscriptionSource !== 'paddle'
  );
}
